import { Tooltip, TooltipProps } from 'antd'

export { Tooltip }
export type { TooltipProps }
